import React from 'react';
import { AppBar, UserMenu, TitlePortal } from 'react-admin';
import { Box } from '@mui/material';
import { LanguageSwitcher } from './LanguageSwitcher';

// Кастомное меню пользователя, которое заменяет стандартное
const CustomUserMenu = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <LanguageSwitcher />
    <UserMenu />
  </Box>
);

export const CustomAppBar = () => (
  <AppBar 
    userMenu={<CustomUserMenu />}
    // Отключаем автоматический переключатель языка React Admin
    sx={{
      '& .RaAppBar-languageSwitcher': {
        display: 'none !important'
      }
    }}
  >
    <TitlePortal />
  </AppBar>
);
